/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import { device, Common } from '@stockbit/ui';
import Image from 'global/Image';

const { Flex, Modal: ModalAntd } = Common;

export const VisionBox = styled.section`
  @media ${device.tablet} {
    width: calc(100% - 400px);
    margin-right: 40px;
  }
`;

export const VisionImage = styled(Image)`
  display: none;
  @media ${device.tablet} {
    display: block;
  }
`;

export const ManagementContainer = styled(Flex).attrs({
  align: 'flex-start',
  justify: 'center',
})`
  display: grid;
  grid-template-columns: auto auto;
  grid-column-gap: 28px;
  grid-row-gap: 28px;
  flex-direction: column;

  &:last-child {
    > div:first-child {
      grid-column: 1 / span 2;
      margin-bottom: 0;
      margin-top: 28px;
    }
  }

  @media ${device.tablet} {
    flex-direction: column;
    display: flex;
  }

  @media ${device.laptop} {
    flex-direction: row;
  }
`;

export const Card = styled.div<{ active: boolean }>`
  padding: 12px;
  border-radius: 12px;
  box-sizing: border-box;
  border: ${props => (props.active ? '2px solid #00AB6B' : '1px solid #ededed')};
  margin: 14px 0px;
  min-height: 100%;

  /** &:not(.position-3) {
    width: calc(50% - 14px);
    float: left;
  }

  &.position-1,
  &.position-4 {
    margin-right: 14px;
  }

  &.position-2,
  &.position-5 {
    margin-left: 14px;
  } **/

  @media ${device.tablet} {
    padding: 40px;
    min-height: 1px;
  }

  @media ${device.laptop} {
    width: 33%;
    margin: 20px 10px;
    min-height: 1px;
  }

  &:hover,
  &:focus,
  &:active {
    border: 2px solid #00AB6B;
  }
`;

export const Modal = styled(ModalAntd)`
  .ant-modal-body {
    padding: 40px;
    border-radius: 12px;
  }

  .ant-modal-close{
    display: none;
    visibility: hidden;
    opacity: 0;
  }
`;